import {
    ButtonStyle as ButtonGradient, LinkStyle as LinkGradient, InputSubmitStyle as InputGradient,
    LabelButtonStyle as ButtonLabel, SubmitButtonStyle, SubmitButtonContainerStyle, SubmitButtonErrorText, SubmitButtonSuccessText, LinkOutsideSite
} from "./style";
import React from 'react';
import { SaveAndContinueLater } from "../SaveAndContinueLater";
import { WarningMessageSubmitContainer } from "../WarningMessage/style";
import { WarningMessage } from "../WarningMessage";

export { ButtonGradient, LinkGradient, InputGradient, ButtonLabel, LinkOutsideSite };

export const SubmitButton = ({
    mainColor,
    value = "Invia",
    errorText = '',
    successText = '',
    onClickSaveAndContinueLater = null,
    disabled = false,
    onClick = () => { },
}) => {
    return (
        <SubmitButtonContainerStyle>
            {errorText &&
                <WarningMessageSubmitContainer>
                    <WarningMessage
                        text={errorText}
                    />
                </WarningMessageSubmitContainer>
            }
            {successText &&
                <WarningMessageSubmitContainer>
                    <WarningMessage
                        text={successText} isSuccess={true}
                    />
                </WarningMessageSubmitContainer>
            }
            <SubmitButtonStyle
                type="submit"
                value={value}
                onClick={onClick}
                mainColor={mainColor}
                disabled={disabled}
            />
            {/* {errorText && <SubmitButtonErrorText>{errorText}</SubmitButtonErrorText>} */}
            {onClickSaveAndContinueLater && <SaveAndContinueLater onClick={onClickSaveAndContinueLater} />}
        </SubmitButtonContainerStyle>
    )
}

